import DateTimeDisplay from '@/components/DateTime';
import { Box } from '@palmetto/palmetto-components';

import { DocumentDocument } from 'types';

export const InvoiceDocumentItem = ({ document }: { document: DocumentDocument }) => {
  const file = document.files && document.files.length > 0 ? document.files[0] : null;

  const externalReference =
    typeof document?.externalReference === 'number'
      ? String(document.externalReference)
      : document?.externalReference?.trim();

  const invoiceNumber = externalReference || 'Manually uploaded';

  return (
    <Box borderWidth="0 0 xs 0" borderColor="separator" direction="row" padding="md 0" childGap="3xl">
      <Box width="20">{invoiceNumber}</Box>
      <Box width="20">
        {document.meta?.createdAt ? <DateTimeDisplay displayLocalDateTime value={document.meta.createdAt} /> : null}
      </Box>
      <Box>
        <a
          href={file?.viewUrls?.[0]?.url}
          target="_blank"
          rel="noopener noreferrer"
          title={file?.originalName}
          style={{ textDecoration: 'underline' }}
        >
          {file?.originalName || 'View Document'}
        </a>
      </Box>
    </Box>
  );
};
